(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('pargi-entered');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08 });
  const watch = () => document.querySelectorAll('product-card, .pargi-help__benefits > div').forEach(el => observer.observe(el));
  watch();
  document.addEventListener('shopify:section:load', watch);
})();
